//功能性组件
export var functionalComponents = [{
  type: "role_id",
  label: "角色ID",
  placeholder: "请输入角色ID",
  value: "",
  isRequired: true
}, {
  type: "server_name",
  label: "区服名称",
  placeholder: "请输入角色ID",
  value: "",
  isRequired: false
}, {
  type: "phone",
  label: "手机验证",
  placeholder: "请输入角色ID",
  value: "",
  isRequired: false
}];
//输入型组件
export var inputComponents = [{
  type: "input",
  label: "单行输入",
  paramDesc: "单行输入",
  paramType: "String",
  value: "",
  isRequired: 0
}, {
  type: "textarea",
  label: "多行输入",
  paramDesc: "多行输入",
  paramType: "String",
  value: "",
  isRequired: 0
}];

//选择型组件
export var selectComponents = [{
  type: "select",
  label: "下拉选项",
  paramDesc: "下拉选项",
  value: "",
  paramType: "String",
  option: [{
    label: "选项1"
  }],
  isRequired: 0
}, {
  type: "switch",
  label: "开关",
  paramDesc: "开关",
  paramType: "Number",
  value: 0,
  isRequired: 0
}, {
  type: "radio",
  label: "单选框",
  paramDesc: "单选框",
  paramType: "Array",
  value: "",
  option: [{
    label: "选项1"
  }],
  isRequired: 0
}, {
  type: "checkbox",
  label: "多选框",
  paramDesc: "多选框",
  paramType: "Array",
  value: [],
  option: [{
    label: "选项1"
  }],
  isRequired: 0
}, {
  type: "datePicker",
  label: "日期选择",
  paramDesc: "日期选择",
  paramType: "String",
  value: "",
  isRequired: 0
}
// {
//     type: "uploadImage",
//     label: "上传图片",
//     paramDesc: "上传图片",
//     paramType: "String",
//     value: "",
//     isRequired: 0,
// },
// {
//     type: "file",
//     label: "上传文件",
//     paramDesc: "上传文件",
//     paramType: "String",
//     value: "",
//     isRequired: 0,
// }
];

export var auxiliaryComponents = [{
  type: "hr",
  label: "分割线",
  paramType: "String",
  paramDesc: "分割线",
  value: ""
}];